export default __webpack_public_path__ + "static/media/numpy.91d932ca.svg";